import React, { useRef, useState } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import PropTypes from "prop-types";
import styles from "./GroupPluginsList.module.css";
import classNames from "classnames";

import GroupPluginItem from "../GroupPluginItem";
import ViewPluginDetailsModal from "DreamStream/PluginsPage/Shared/ViewPluginDetailsModal";
import PluginDetailsItem from "DreamStream/PluginsPage/Shared/PluginDetailsItem";

import { useDeletePlugins } from "DreamStream/PluginsPage/usePlugins";

/**
 * Interactive component.
 * Scrollable list of group plugins with a header.
 */
export function GroupPluginsList({ plugins, onClick }) {
  const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref); // Now we pass the reference to the useDraggable hook:

  const { deletePlugin } = useDeletePlugins();

  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [selectedPlugin, setSelectedPlugin] = useState(null);

  const handleDetails = (data) => {
    setDetailsModalOpen(true);
    setSelectedPlugin(data);
  };

  const handleGroupDelete = () => {
    var deleteObject = {
      type: "group",
      deleteData: {
        pluginId: selectedPlugin.targetId,
        iboNumber: selectedPlugin.plugeeIBONumber,
        groupId: selectedPlugin.targetGroupId,
      },
    };
    deletePlugin.mutateAsync(deleteObject);
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.item}>Plugee IBO</div>
          <div className={styles.item}>Plugee Name</div>
          <div className={classNames(styles.itemIboText)}>Target IBO</div>
          <div className={classNames(styles.itemOrgText)}>Target Org/Group</div>
          <div className={styles.item}>As Admin</div>
        </div>

        <div className={classNames(styles.dragger)} {...events} ref={ref}>
          {plugins.map((item, index) => (
            <div
              className={
                index % 2 === 0 ? styles.backgroundWhite : styles.backgroundGray
              }
              key={index}
            >
              <GroupPluginItem
                pluginInfo={item}
                onClick={() => handleDetails(item)}
              />
            </div>
          ))}
        </div>

        <ViewPluginDetailsModal
          title="VIEW GROUP PLUGIN DETAILS"
          isOpen={detailsModalOpen}
          errors={[]}
          onClose={() => setDetailsModalOpen(false)}
          onDelete={handleGroupDelete}
          children={
            <>
              {selectedPlugin && (
                <div className={styles["modal-container"]}>
                  <div className={styles["detail-container"]}>
                    <div className={styles["label-column"]}>Plugin ID:</div>
                    <div className={styles["detail-column"]}>
                      {selectedPlugin.id}
                    </div>
                  </div>
                  <div className={styles["detail-container"]}>
                    <div className={styles["label-column"]}>
                      The Following IBO
                    </div>
                    <div className={styles["detail-column"]}>
                      <PluginDetailsItem
                        // src="https://wwguscms.blob.core.windows.net/images/cms/thumbnail/793844d0-334a-11ec-882f-dfd435b7f374/EwiHH-fWUAUavjX.jpeg"
                        name={selectedPlugin.plugeeName}
                        isGroup={false}
                        id={selectedPlugin.plugeeIBONumber}
                      />
                    </div>
                  </div>
                  <div className={styles["detail-container"]}>
                    <div className={styles["label-column"]}>
                      Is Plugged Into Group
                    </div>
                    <div className={styles["detail-column"]}>
                      <PluginDetailsItem
                        // src="https://wwguscms.blob.core.windows.net/images/cms/thumbnail/793844d0-334a-11ec-882f-dfd435b7f374/EwiHH-fWUAUavjX.jpeg"
                        name={`${selectedPlugin.targetOrganizationName} > ${selectedPlugin.targetGroupName}`}
                        isGroup={true}
                        id={selectedPlugin.targetGroupId}
                      />
                    </div>
                  </div>
                  <div
                    className={classNames(
                      styles["detail-container"],
                      styles["detail-admin"]
                    )}
                  >
                    <div className={styles["label-column"]}>As</div>
                    <div className={styles["detail-column"]}>
                      {selectedPlugin
                        ? selectedPlugin.asAdmin
                          ? "Admin"
                          : "Not Admin"
                        : ""}
                    </div>
                  </div>
                  {/* <div className={styles["detail-container"]}>
                    <div className={styles["label-column"]}>Date Created</div>
                    <div className={styles["detail-column"]}>
                      {`${selectedPlugin.date} ${selectedPlugin.time}`}
                    </div>
                  </div> */}
                </div>
              )}
            </>
          }
        />
      </div>
    </>
  );
}

GroupPluginsList.propTypes = {
  /**
   * Array of plugin objects.
   */
  plugins: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      iboName: PropTypes.string,
      groupName: PropTypes.string,
      asAdmin: PropTypes.bool,
      date: PropTypes.string,
      time: PropTypes.string,
    })
  ),
  /**
   * Function that fires when the details buttons are clicked.
   */
  onClick: PropTypes.func,
};
